const currentHost = (<any>window).DJANGO.currentHost;
const Weglot = (<any>window).Weglot;

export function initialise() {
    const allowedSSDomainsToConvert = [
        'www.laphil.com',
        'www.hollywoodbowl.com',
        'www.theford.com',
        'www.laphil.devspace.net',
        'www.hollywoodbowl.devspace.net',
        'www.theford.devspace.net',
        'www.laphil.docker',
        'www.hollywoodbowl.docker',
        'www.theford.docker',
        'www.laphil.site',
        'www.hollywoodbowl.site',
        'www.theford.site',
    ]

    const allowedBODomainsToConvert = [
        'tickets.laphil.site',
        'tickets.hollywoodbowl.site',
        'tickets.theford.site',
        'tickets.laphil.docker',
        'tickets.hollywoodbowl.docker',
        'tickets.theford.docker',
        'tickets-dev.laphil.devspace.net',
        'tickets-dev.hollywoodbowl.devspace.net',
        'tickets-dev.theford.devspace.net',
        'tickets-webdev.laphil.devspace.net',
        'tickets-webdev.hollywoodbowl.devspace.net',
        'tickets-webdev.theford.devspace.net',
        'my.laphil.com',
        'my.hollywoodbowl.com',
        'my.theford.com',
    ]

    let isRunning = false;

    // Run other methods only after initialized
    const interval = setInterval(()=> {
        if (!Weglot.initialized || isRunning) {
            return;
        }

        isRunning = true;
        // clearInterval(interval);
        updateLinkSubdomains(allowedSSDomainsToConvert, allowedBODomainsToConvert);
        isRunning = false;
    }, 100);
}

function updateLinkSubdomains(allowedSSDomainsToConvert, allowedBODomainsToConvert) {
    const currentLang = Weglot.getCurrentLang();
    const originalLang = Weglot.options.language_from;

    if (originalLang === currentLang) {
        return;
    }

    const anchors = document.getElementsByTagName("a");

    [].forEach.call(anchors, (anchor) => {
        if(anchor.href) {
            let url = new URL(anchor.href);
            if (allowedBODomainsToConvert.indexOf(url.hostname) !== -1) {
                if (url.pathname.includes('/' + originalLang + '/')) {
                    anchor.href = anchor.href.replace(originalLang, currentLang);
                } else if (!url.pathname.includes('/' + currentLang + '/')) {
                    anchor.setAttribute('href', url.origin + '/' + currentLang + url.pathname);
                }
            } else if (allowedSSDomainsToConvert.indexOf(url.hostname) !== -1) {
                anchor.setAttribute('href', url.href.replace('www.', currentLang + '.'));
            }
        }
    });
}

initialise();



// WEBPACK FOOTER //
// ./@modules/vendor/link-checker.ts